import type { ThemeConfig } from 'antd';

export const appTheme: ThemeConfig = {
  token: {
    colorPrimary: '#ba2822',
    borderRadius: 10,
    colorBgLayout: '#f5f7fa',
    colorLink: '#1677ff',
  },
  components: {
    Layout: {
      headerBg: '#ffffff',
      bodyBg: '#f5f7fa',
      siderBg: '#001529',
      triggerBg: '#002140',
    },
    Menu: {
      darkItemSelectedBg: '#1677ff',
      itemBorderRadius: 8,
      itemMarginInline: 10,
    },
    Tabs: {
      cardBg: '#ffffff',
    },
  },
};
